/**
 *  GET,PUT,POST,DELETE methods for API calls implemented here
 */
import axios from 'axios';
import qs from 'qs';
import { utils } from '../../devUtils/index';

export const createAxiosInstance = (type, headers) => {
  const PORT = parseInt(process.env.PORT, 10) || 9506;
  switch (type) {
    case 'SSR':
      return axios.create({
        baseURL: `http://localhost:${PORT}/api`,
        headers,
      });
    default:
      return axios.create({
        baseURL: '/api',
      });
  }
};

// const getHeaderConfiguaration = (type) => {
//   // const secureToken = window.sessionStorage.getItem("SecureToken");
//   // console.log("get header", secureToken);
//   return {
//     headers: {
//       Accept: (type === 'TEXT') ? 'text/html' : 'application/json',
//       'Content-type': 'application/json',
//       //   "Authorization": (secureToken) ? "Bearer " + secureToken : "No token",
//       'Access-Control-Allow-Origin': '*',
//       'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE',
//       'Access-Control-Allow-Headers': 'Authorization',
//     },
//     crossDomain: true,
//   };
// };
const getHeaderConfiguaration = (params) => {
  const { token, device_id, client_id } = params;
  const Authorization = utils.addAuthorizationHeaders(token, device_id, client_id);
  return { Authorization };
};
/**
 * @desc 1) @func when need to call the API from at the time of page load
 *       2) dispatcher is not in the loader.js file
 *       3) @returns @default axios when need to hit same project express rest handler
 * @param {axios} api function
 */
const getInstance = (api) => {
  let API = api;
  if (typeof API !== 'function') {
    API = axios;
  }
  return API;
};

/**
 * get axios call
 * @param {*string} url
 * @param {object} otherParams is value need to converted in formData
 *         @param {*boolean} isAuth
 *         @default isPlainJS: undefined
 *         @param {*string} token
 *         @param {*string} device_id
 * @returns Promise
 */
export const getData = (api, url, params, otherParams = {}) => {
  const { isAuth, ...restParams } = otherParams;
  if (!params && isAuth) {
    const headers = getHeaderConfiguaration(restParams);
    return api.get(url, { headers });
  } else if (params && isAuth) {
    const headers = getHeaderConfiguaration(restParams);
    return api.get(url, { params, headers });
  } else if (params && !isAuth) {
    return api.get(url, { params });
  }
  return api.get(url);
};
// export const getData = (api, url, params) => {
//   // const config = getHeaderConfiguaration();
//   if (params) {
//     return api.get(url, { params });
//   }
//   return api.get(url);
// };

/**
 * post axios call
 * @argument data converting to stringify {form-data} for mobile-api written in PHP with base url :https://group-dining-api.zaggle.in/
 * @param {string} url
 * @param {JSON} data
 * @param {object} otherParams is value need to converted in formData
 *          @param {*boolean} isAuth
 *          @default isPlainJS: undefined
 *          @param {*string} token
 *          @param {*string} device_id
 * @func getInstance checking the axistance of axios instance
 * @returns promise
 */
export const postData = (api, url, data, otherParams = {}, isPlainJsData = false) => {
  const { isAuth, isPlainJS, ...restParams } = otherParams;
  let querystringData = '';
  if (isPlainJsData) {
    querystringData = data;
  } else {
    querystringData = isPlainJS ? data : qs.stringify(data);
  }
  const API = getInstance(api);
  if (isAuth) {
    const headers = getHeaderConfiguaration(restParams);
    return API.post(url, querystringData, { headers });
  }
  return API.post(url, querystringData);
};

// export const postData = (api, url, data, isOrgData) => {
//   // const config = getHeaderConfiguaration();
//   // return axios.post(url, data, config);
//   const querystringData = !isOrgData ? qs.stringify(data) : data;
//   const API = getInstance(api);
//   return API.post(url, querystringData);
// };

/**
 * delete axios call
 * @param {string} url
 * @param {string} identifier
 * @returns Promise
 * @desc not using any where
 */

export const deleteData = (api, url, params, otherParams = {}) => {
  const { isAuth, isPlainJS, ...restParams } = otherParams;
  if (isAuth) {
    const headers = getHeaderConfiguaration(restParams);
    return api.delete(url, { params, headers });
  }
  return api.delete(url, { params });
};

/**
 * put axios call
 * @param {string} url
 * @param {string} data
 * @desc not using any where
 */
export const putData = (api, url, data, otherParams = {}) => {
  const { isAuth, isPlainJS, ...restParams } = otherParams;
  if (isAuth && data) {
    const headers = getHeaderConfiguaration(restParams);
    return api.put(url, data, { headers });
  } else if (data) {
    return api.put(url, data);
  }
  return api.put(url);
};



// WEBPACK FOOTER //
// client/config/services/index.js